import React, { FC } from "react";
import { Control } from "react-hook-form";

import CheckboxBase, { CheckboxBaseProps } from "@/components/ui/Form/Filters/components/Checkbox/CheckboxBase";
import CheckboxControlled from "@/components/ui/Form/Filters/components/Checkbox/CheckboxControlled";

export interface CheckboxProps extends CheckboxBaseProps {
  control?: Control<any>;
}
const Checkbox: FC<CheckboxProps> = (args) => {
  return <>{args?.control ? <CheckboxControlled control={args.control} {...args} /> : <CheckboxBase {...args} />}</>;
};
export default Checkbox;
